import { render, staticRenderFns } from "./reportRepairList.vue?vue&type=template&id=04da972e&scoped=true"
import script from "./reportRepairList.vue?vue&type=script&lang=js"
export * from "./reportRepairList.vue?vue&type=script&lang=js"
import style0 from "./reportRepairList.vue?vue&type=style&index=0&id=04da972e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04da972e",
  null
  
)

export default component.exports